import { useEffect, useState } from 'react';
import Product1 from '../Img/Product1.png'
import Product2 from '../Img/Product2.png'
import Product3 from '../Img/Product3.png'
import { useNavigate } from 'react-router-dom';
import Checkout from './Checkout';
import decryptCookieData from './Functions/decryptCookieData';
import { toast, ToastContainer } from 'react-toastify';
import EmptyCartImg from "../Img/EmptyCartImg.png"

// const products = [
//     {
//         id: 1, 
//         name: 'Product Name 1',
//         img: Product1,
//         deliveryStart: '27 March 2025',
//         deliveryEnd: '30 March 2025',
//         discountPrice: 100.00,
//         originalPrice: 200.00
//     },
//     {
//         id: 2,
//         name: 'Product Name 2',
//         img: Product2,
//         deliveryStart: '28 March 2025',
//         deliveryEnd: '31 March 2025',
//         discountPrice: 120.00,
//         originalPrice: 220.00
//     },
//     {
//         id: 3,
//         name: 'Product Name 3',
//         img: Product3,
//         deliveryStart: '29 March 2025',
//         deliveryEnd: '1 April 2025',
//         discountPrice: 150.00,
//         originalPrice: 250.00
//     }
// ];
const getDeliveryDate = (days) => {
    const date = new Date();
    date.setDate(date.getDate() + Number(days));
    return date.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }); // Example: "18 May 2025"
};


const Cart = ({ cartItemsLength, setCartItemLength, fetchCart1 }) => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [couponCode, setCouponCode] = useState("");
    const [products, setProducts] = useState([]);
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    console.log(userData)

    const [discount, setDiscount] = useState(0);
    const url = process.env.REACT_APP_API_URL

    const applyCoupon = async () => {
        if (!couponCode.trim()) {
            toast.warn("Please enter a coupon code");
            return;
        }

        try {
            const response = await fetch(`${url}/coupon/check/${couponCode}?user_id=${process.env.REACT_APP_PERFUME_ID}`);
            const result = await response.json();

            if (response.ok && result.couponData) {
                toast.success(result.message);

                // ✅ Use correct original total
                const originalTotal = products.reduce((acc, p) => acc + Number(p.product_saleprice), 0);
                let discountAmt = 0;
                console.log(originalTotal)
                if (result.couponData.percentage_offer) {
                    discountAmt = (originalTotal * result.couponData.percentage_offer) / 100;
                } else if (result.couponData.price_offer) {
                    discountAmt = result.couponData.price_offer;
                }

                setDiscount(discountAmt);
            }
            else {
                toast.error(result.message || "Invalid coupon");
            }
        } catch (error) {
            console.error("Coupon check failed:", error);
            toast.error("Error checking coupon");
        }

        setIsOpen(false);
    };
    console.log(discount)
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || ""
        if (user && user.user_id) {
            fetchCart(user.user_id);
        } else {
            const guestCart = JSON.parse(localStorage.getItem('guest_cart')) || [];
            setProducts(guestCart);
        }
    }, []);

    const safeParse = (val, fallback = {}) => {
        try {
            return typeof val === "string" ? JSON.parse(val) : val || fallback;
        } catch (err) {
            return fallback;
        }
    };

    const fetchCart = async (user_id) => {
        try {
            const response = await fetch(`${url}/cart/${user_id}`);
            const result = await response.json();
            if (!result.isError) {
                const parsed = result.data.map(p => ({
                    ...p,
                    variation_attributes: safeParse(p.variation_attributes, {}),
                    product_gallery: safeParse(p.product_gallery, []),
                }));
                setProducts(parsed);
            } else {
                toast.error("Failed to fetch cart");
            }
        } catch (error) {
            console.error("Fetch cart error:", error);
            toast.error("Error fetching cart");
        }
    };




    const handleRemoveProduct = async (productId) => {
        if (userData?.user_id) {
            // Logged-in: remove from backend
            try {
                const response = await fetch(`${url}/cart/${productId}`, {
                    method: "DELETE"
                });
                const res = await response.json();
                if (!res.isError) {
                    setProducts(prev => prev.filter(p => p.product_sku !== productId));
                    await fetchCart1(userData?.user_id)
                    toast.success("Product removed from cart");
                } else {
                    toast.error("Failed to remove product");
                }
            } catch (err) {
                console.error("Error removing cart item:", err);
                toast.error("Something went wrong");
            }
        } else {
            // Guest: remove from localStorage
            const updatedCart = (JSON.parse(localStorage.getItem("guest_cart")) || []).filter(
                item => item.product_sku !== productId
            );
            localStorage.setItem("guest_cart", JSON.stringify(updatedCart));
            setProducts(updatedCart);
            setCartItemLength(updatedCart.length)
            toast.success("Product removed from cart");
        }
    };


    // const handleCheckout = () => {
    //     const totalSalePrice = products.reduce((acc, p) => acc + Number(p.product_saleprice), 0);
    //     const totalBeforeDiscount = products.reduce((acc, p) => acc + Number(p.product_price), 0)
    //     const totalAfterDiscount = (totalSalePrice - discount).toFixed(2);

    //     const checkoutDetails = {
    //         products,
    //         coupon: couponCode || null,
    //         discountAmount: discount,
    //         totalBeforeDiscount: totalBeforeDiscount,
    //         totalAfterDiscount,
    //         isCouponApplied: !!discount,
    //     };

    //     localStorage.setItem("checkout_data", JSON.stringify(checkoutDetails));
    //     if (userData) {
    //         navigate("/checkout");
    //     } else {
    //         navigate("/login");
    //         sessionStorage.setItem("navigatepage", "/checkout")
    //     }
    // };

    const [triggerShake, setTriggerShake] = useState(false);

    useEffect(() => {
        if (products.length === 0) {
            setTriggerShake(true);
            const timeout = setTimeout(() => setTriggerShake(false), 700); // remove class after animation ends
            return () => clearTimeout(timeout);
        }
    }, [products]);



    const handleCheckout = () => {
        if (!products || products.length === 0) {
            toast.warn("Your cart is empty!");
            return;
        }

        const totalSalePrice = products.reduce((acc, p) => acc + Number(p.product_saleprice), 0);
        const totalBeforeDiscount = products.reduce((acc, p) => acc + Number(p.product_price), 0);
        const totalAfterDiscount = (totalSalePrice - discount).toFixed(2);

        const checkoutDetails = {
            products,
            coupon: couponCode || null,
            discountAmount: discount,
            totalBeforeDiscount: totalBeforeDiscount,
            totalAfterDiscount,
            isCouponApplied: !!discount,
        };

        localStorage.setItem("checkout_data", JSON.stringify(checkoutDetails));
        if (userData) {
            navigate("/checkout");
        } else {
            navigate("/login");
            sessionStorage.setItem("navigatepage", "/checkout");
        }
    };




    return (
        <>
            <ToastContainer position="top-center" autoClose={3000} />
            <div className="cart-perfume">
                <div className="cart-perfume-header">Your cart</div>
                <div className="cart-columns-perfume">
                    <div className="cart-column1-perfume">
                        <div
                            className="cart-column1-coupon-perfume"
                            onClick={() => setIsOpen(true)}

                        >
                            <i className="fa-solid fa-ticket"></i> Apply Coupon
                        </div>
                        {products.length === 0 ? (
                            <div className="empty-cart-container">
                                <img src={EmptyCartImg} alt="Empty Cart"  className={`empty-cart-image ${triggerShake ? 'shake-animation' : ''}`} />
                                <div>
                                    <p className='emptyecom-cart-container'>Your Cart is Empty!</p>
                                    <button className="empty-cart-buy-now" onClick={() => navigate("/")}>
                                        Buy Now
                                    </button>
                                </div>
                            </div>
                        ) :
                            (products.map((product) => (
                                <div key={product.id} className="cart-column1-product-perfume">
                                    <div className="cart-product-card-perfume cart-product-img">
                                        <img src={`${url}${product.product_image}`} alt={product.name} />
                                    </div>
                                    <div className="cart-product-card-perfume cart-product-details">
                                        <div className="cart-product-details-column1">
                                            <h3>{product.product_name}</h3>
                                            {product.delivery_days ? (
                                                <p className="cart-delivery-time">
                                                    Delivery by <strong>{getDeliveryDate(product.delivery_days)}</strong>
                                                </p>
                                            ) : null}



                                            {product.variation_attributes && Object.entries(product.variation_attributes).map(([key, value]) => (
                                                <p key={key}><strong>{key}:</strong> {value}</p>
                                            ))}

                                            <button className="cart-remove-product" onClick={() => handleRemoveProduct(product.product_sku)}>
                                                <i className="fa-solid fa-trash"></i> Remove
                                            </button>

                                        </div>
                                        <div className="cart-product-details-column2">
                                            <h3 className="cart-discount-price"><strong>₹{Number(product.product_saleprice).toFixed(2)}</strong></h3>
                                            <p className="cart-original-price">₹{Number(product.product_price).toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>
                            )))}
                    </div>
                    <div className="cart-column2-perfume">
                        <div className="cart-column2-header-perfume">
                            <h3>Order summary ({products.length} items)</h3>
                        </div>
                        <div className="cart-column2-total-perfume">
                            <div className="cart-total-labels">
                                <p><strong>Total Price</strong></p>
                                <p>Original Price</p>
                            </div>
                            <div className="cart-total-value">
                                {/* <p><strong>₹{(products.reduce((acc, p) => acc + Number(p.product_price), 0) - discount).toFixed(2)}</strong></p> */}

                                <p><strong>₹{(products.reduce((acc, p) => acc + Number(p.product_saleprice), 0) - discount).toFixed(2)}</strong></p>
                                <p>₹{(products.reduce((acc, p) => acc + Number(p.product_price), 0)).toFixed(2)}</p>
                            </div>
                        </div>
                        <div className="cart-checkout-btn" onClick={handleCheckout}>
                            <button className="cart-checkout-btn" >Checkout</button>
                        </div>
                    </div>
                </div>
            </div>

            {isOpen && (
                <div className="coupon-modal">
                    <div className="coupon-modal-content">
                        <span className="coupon-close" onClick={() => setIsOpen(false)}><i className="fa-solid fa-xmark"></i></span>
                        <h3 className="coupon-title">Apply Coupon</h3>
                        <input
                            type="text"
                            className="coupon-input"
                            placeholder="Enter Coupon Code"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                        />
                        <button className="coupon-apply-btn" onClick={applyCoupon} >
                            Apply Coupon
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Cart;